import { delimitNumber } from '@src/utils';

const calculateDiscountedPrice = (item) => {
  const { priceOut = 0, quantity = 0, discount = 0 } = item;
  const isMoney = (v) => v >= 1000;

  let finalPrice = priceOut;

  if (isMoney(discount)) {
    finalPrice -= discount;
  } else {
    finalPrice -= (priceOut * discount) / 100;
  }

  return delimitNumber(finalPrice * quantity);
};

export { calculateDiscountedPrice };
